import { CustomLink } from "Shared/CustomLink";
import { Typography, useTheme } from "@mui/material";
import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";

type NavbarButtonProps = {
  href: string;
  label?: string;
  customWidth?: number;
  icon?: ReactNode;
};

export const NavbarButton = ({
  href,
  label,
  customWidth,
  icon,
}: NavbarButtonProps) => {
  const { colors, customFontWeight, customSpacing, radius } = useTheme();
  const location = useLocation();
  const isActive = location.pathname === href;

  return (
    <CustomLink
      href={href}
      style={{
        textDecoration: "none",
        backgroundColor: isActive
          ? colors.background.inverse
          : colors.background.hover,
        height: 40,
        borderRadius: radius.full,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: customWidth,
        gap: customSpacing.md,
      }}
    >
      {icon}
      {label && (
        <Typography
          variant="body3"
          fontWeight={customFontWeight.bold}
          sx={{
            padding: `${customSpacing.xs} ${customSpacing.xl}`,
            color: isActive ? colors.text.inverse : colors.text.primary,
          }}
        >
          {label}
        </Typography>
      )}
    </CustomLink>
  );
};
